import { render } from "./NetworkSvg.vue?vue&type=template&id=418bbcfa&bindings={}"
import script from "./NetworkSvg.vue?vue&type=script&lang=ts"
export * from "./NetworkSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script